var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from '../elements/svg-circle-icon';
export var LocationIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 52,
    glyphHeight: 64
  }), React.createElement("path", {
    d: "M26 32.2609C29.4578 32.2609 32.2609 29.4578 32.2609 26C32.2609 22.5422 29.4578 19.7391 26 19.7391C22.5422 19.7391 19.7391 22.5422 19.7391 26C19.7391 29.4578 22.5422 32.2609 26 32.2609Z"
  }), React.createElement("path", {
    d: "M26 9.30437C35.1826 9.30437 42.6957 16.8174 42.6957 26C42.6957 33.0957 34.1392 44.1565 26 52.2957C18.487 44.9913 9.30437 33.7218 9.30437 26C9.30437 16.8174 16.8174 9.30437 26 9.30437ZM26 0.956543C12.2261 0.956543 0.956543 12.2261 0.956543 26C0.956543 42.6957 26 63.5652 26 63.5652C26 63.5652 51.0435 42.6957 51.0435 26C51.0435 12.2261 39.7739 0.956543 26 0.956543Z"
  }));
};
export var LocationIconGlyph = function (props) {
  return React.createElement(LocationIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};